import getFontsMap from "./getFontsMap";
import {fontWeightsArray, fontSizesArray} from "./fontArrays";

const fontsMap = getFontsMap();

const customInlineStylesMap = {
  ...fontsMap,
  'UPPERCASE': {
    'textTransform': 'uppercase',
  },
  'LOWERCASE': {
    'textTransform': 'lowercase',
  },
};

fontWeightsArray.forEach(weight => {customInlineStylesMap[`FONTWEIGHT_${weight}`] = {fontWeight: weight}});

fontSizesArray.forEach(size => {customInlineStylesMap[`FONTSIZE_${size}`] = {fontSize: size}});

export default customInlineStylesMap;